import { html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { OutlineCard } from '../../base/outline-card/outline-card';
import '../ghs-icon/ghs-icon';

import componentStyles from './ghs-statistics-card.css.lit';
import { LightController } from '../../controllers/light-controller';

/**
 * The Statistics Card component.
 * @element ghs-statistics-card
 * @slot default - The default slot.
 */
@customElement('ghs-statistics-card')
export class GhsStatisticsCard extends OutlineCard {
  static styles = [componentStyles];

  lightController = new LightController(
    this,
    GhsStatisticsCard.styles,
    this.tagName.toLowerCase()
  );

  /**
   * Background color of the card. Defaults to 'white'
   */
  @property({ type: String, attribute: 'bg-color', reflect: true })
  bgColor: 'dark' | 'light' | 'white' = 'white';

  render(): TemplateResult {
    const wrapperClasses = {
      'bg-color': this.bgColor,
    };

    return html`
      <div class="statistics-card ${classMap(wrapperClasses)}">
        <slot></slot>
      </div>
    `;
  }
}
